let $sliders = $('.speakers-js');
$('.speaking-play-js').click(function() {
  let $this = $(this);
  let lessonType = $this.data('id');
  let tariff = $this.data('tariff');

  openPaymentForm({
    lessonType,
    tariff,
  });
});

initSliders();
window.addEventListener('resize', function() {
  $sliders.each((key, slider) => {
    setTimeout(function() {
      let $slider = $(slider);
      let $currentSlide = $slider.find('.owl-item.active .speakers__slide');
      let $toNextBlock = $slider.find('.to-next-slide');
      $toNextBlock.css({height: $currentSlide.height() + 'px'});
    }, 500);
  });
});

function initSliders() {
  $sliders.each((key, slider) => {
    initSlider($(slider));
  });
}

function getCurrentLanguage($slider) {
  return parseInt($slider.closest('.speakers__content')
                .find('.language-select li.active')
                .data('id'));
}

function initSliderLanguage($slider, slides) {
  let currentLanguage = getCurrentLanguage($slider);
  $slider.trigger('destroy.owl.carousel');

  $slider.html('');
  slides.forEach(slide => {
    if(parseInt(slide.language) === currentLanguage){
      $slider.append(slide.html);
    }
  });

  $slider.owlCarousel({
    margin: 15,
    nav: true,
    navText: ['', ''],
    dots: false,

    onChanged: updateNextPreview,
    onInitialized: updateNextPreview,

    responsive: {
      0: {
        items: 1,
        autoHeight: true,
      },
      560: {
        items: 2,
      },
      769: {
        items: 1,
      },
    },
  });
}

function initSlider($slider) {
  //store all slides HTML without filter by language
  let slides = [];
  $slider.find('.speakers__slide').each((key, slide) => {
    slides.push({
      html: slide.outerHTML,
      language: slide.getAttribute('data-language'),
    });
  });

  initSliderLanguage($slider, slides);

  let $languagesItems = $slider.closest('.speakers__content').find('.language-select li');
  $languagesItems.click(function() {
    $slider.animate({opacity: 0}, 600);
    $languagesItems.removeClass('active');
    $(this).addClass('active');

    setTimeout(function() {
      $slider.animate({opacity: 1}, 600);
      initSliderLanguage($slider, slides);
    }, 600);
  });
}

function updateNextPreview(e) {
  let $slider = $(e.target);
  $slider.find('.to-next-slide').remove();
  if(document.documentElement.clientWidth <= 1200 || e.item.count - e.item.index <= 1) {
    return;
  }
   let $nextSlide = $($slider.find('.owl-item').get(e.item.index + 1));
   let $currentSlide = $($slider.find('.owl-item').get(e.item.index)).find('.speakers__slide');
   let title = $nextSlide.find('.speakers__slide-title').text();
   let $image = $nextSlide.find('.speakers__slide-image');

   let $nextBlock = $(`<div class="to-next-slide" ondragstart="return false;">
                    <div class="to-next-slide__title">${title}</div>
                    <div class="teacher-image to-next-slide__image">
                        ${$image.html()}
                    </div>
                    <div class="next"></div>
                </div>`);
   $slider.append($nextBlock);
   $nextBlock.css({height: $currentSlide.height() + 'px'});
   $nextBlock.on('click', function() {
     $slider.trigger('next.owl.carousel');
   });
}
